<app-activity-search-engine-panel (selectionValidated)="onSelectionValidated($event)"></app-activity-search-engine-panel>
